// extracted by mini-css-extract-plugin
export default {"Root":"opening-screen_Root__bNx-L","LoginOptions":"opening-screen_LoginOptions__IHSl8"};